import { State } from "../Model/State";
export const followMode = new State(loadFollowModeStatus());
followMode.subscribe(state => {
    localStorage.setItem('follow_mode', state ? '1' : '0');
});
export function enableFollowMode() {
    if (followMode.value) {
        return;
    }
    followMode.set(true);
}
export function disableFollowMode() {
    if (!followMode.value) {
        return;
    }
    followMode.set(false);
}
export function toggleFollowMode() {
    followMode.set(!followMode.value);
}
function loadFollowModeStatus() {
    return localStorage.getItem('follow_mode') === '1';
}
